import { MediaSimple as Base } from '@whispli/client/tenant/openapi/client/model/MediaSimple'
import { Expose } from 'class-transformer'
import { withObject } from '../mixins/withObject'

export class MediaSimple extends withObject(Base) {
  @Expose({ groups: [ 'client' ] })
  /**
   * @deprecated For backwards-compatibility only. use downloadUrl
   */
  public get url() {
    return this.downloadUrl
  }

  @Expose({ groups: [ 'client' ] })
  public get filename() {
    return this.fileName
  }
}
